import React from "react";
import styles from "./FiltersBar.module.css";

/** Bowl exercises are always done with both hands, so they have no hand to pick. */
export function isBowlExercise(exercise: string): boolean {
  return exercise.toLowerCase().includes("bowl");
}

/** A hand is needed before fetching, except for bowls. */
export function hasRequiredFilters(hand: string, exercise: string): boolean {
  return !!exercise && (isBowlExercise(exercise) || !!hand);
}

/** The `hand` query value: bowls match every stored hand. */
export function handQueryValue(hand: string, exercise: string): string {
  return isBowlExercise(exercise) ? "any" : hand;
}

type Props = {
  filterHand: string;
  filterExercise: string;
  filterStartDate: string;
  filterEndDate: string;
  dataKey: string;
  setFilterHand: (val: string) => void;
  setFilterExercise: (val: string) => void;
  setStartDate: (val: string) => void;
  setEndDate: (val: string) => void;
  setDataKey: (val: string) => void; 
  showDateRange?: boolean;
};

export default function FiltersBar({
  filterHand,
  filterExercise,
  filterStartDate,
  filterEndDate,
  dataKey,
  setFilterHand,
  setFilterExercise,
  setStartDate,
  setEndDate,
  setDataKey,
  showDateRange = true,
}: Props) {
  return (
    <div className={styles.wrap}>
      {isBowlExercise(filterExercise) ? (
        <select
          aria-label="Filter by hand"
          value="Both"
          disabled
          className={`${styles.field} ${styles.select}`}
        >
          <option value="Both">Both hands</option>
        </select>
      ) : (
        <select
          aria-label="Filter by hand"
          value={filterHand}
          onChange={(e) => setFilterHand(e.target.value)}
          className={`${styles.field} ${styles.select}`}
        >
          <option value="" disabled>
            Select hand
          </option>
          <option value="Left">Left</option>
          <option value="Right">Right</option>
        </select>
      )}

      <select
        aria-label="Filter by Metric"
        value={dataKey}
        onChange={(e) => setDataKey(e.target.value)}
        className={`${styles.field} ${styles.select}`}
      >
        <option value="Accuracy">Accuracy</option>
        <option value="Reps">Reps</option>
        <option value="Duration">Duration</option>
      </select>

      <select
        aria-label="Filter by exercise"
        value={filterExercise}
        onChange={(e) => setFilterExercise(e.target.value)}
        className={`${styles.field} ${styles.select}`}
      >
        <option value="" disabled>
          Select exercise
        </option>
        <option value="Vertical Bowl">Vertical Bowl</option>
        <option value="Horizontal Bowl">Horizontal Bowl</option>
        <option value="Horizontal Mug">Horizontal Mug</option>
        <option value="Vertical Mug">Vertical Mug</option>
        <option value="Sip from Mug">Sip from Mug</option>
        <option value="Quick Twist Mug">Quick Twist Mug</option>
        <option value="Slow Pour Mug">Slow Pour Mug</option>
        <option value="Unlock With Key">Unlock With Key</option>
        <option value="Turn Doorknob">Turn Doorknob</option>
        <option value="Phone Number">Phone Number</option>
        <option value="Quick Tap">Quick Tap</option>
      </select>

      {showDateRange && (
        <>
          <input
            aria-label="Start date"
            type="date"
            value={filterStartDate}
            onChange={(e) => setStartDate(e.target.value)}
            className={`${styles.field} ${styles.date}`}
          />

          <input
            aria-label="End date"
            type="date"
            value={filterEndDate}
            onChange={(e) => setEndDate(e.target.value)}
            className={`${styles.field} ${styles.date}`}
          />
        </>
      )}

  
    </div>
  );
}
